import { HorizontalOriginOption, Tooltip, VerticalOriginOption } from '@tableau/widgets';
import * as React from 'react';

import { imgPath } from '~common/utilities/ImgUrl';
import { interpolateString } from '~common/utilities/StringInterpolation';
import { HelpService } from '~commonInfra/services/HelpService';
import { TooltipAnchor } from '~src/app/spaces/Tooltips/TooltipAnchor';
import { Messages } from '~src/codegen/Localize';

export function BridgeRemoteAgentsSectionHeaders() {
  const tooltipPath = imgPath('info_normal.svg');
  return <>
    <tbody>
      <tr>
        <th className={'tb-data-grid-headers-line'}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'agent-computer-name-column-header'}>
            {Messages.siteRemoteAgentComputerNameColumnName()}
          </span>
        </th>
        <th className={'tb-data-grid-headers-line'}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'agent-owner-column-header'}>
            {Messages.siteRemoteAgentOwnerColumnName()}
          </span>
        </th>
        <th className={'tb-data-grid-headers-line'}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'pool-name-column-header'}>
            {Messages.siteRemoteAgentPoolNameColumnName()}
            <Tooltip testId={'agent-pool-tooltip'} getContent={() => { return <span>{Messages.siteRemoteAgentPoolNamePopoverDetail()}</span>; }}>
              <img style={{ height: 14, marginLeft: 3, verticalAlign: 'text-top', outlineStyle: 'none' }} src={tooltipPath} alt={''} />
            </Tooltip>
          </span>
        </th>
        <th className={'tb-data-grid-headers-line'} key={0}>
          <div className={'tb-data-grid-header-text'} data-tb-test-id={'agent-version-column-header'}>
            <TooltipAnchor
              tooltipContent={() => { return <div>{clientUpdateHelpText()}</div>; }}
              width={200}
              title={''}
              disableAutoFocus={true}
              anchorOrigin={{
                horizontal: HorizontalOriginOption.centerX,
                vertical: VerticalOriginOption.top
              }}>
              {Messages.siteRemoteAgentVersionColumnName()}
              <img style={{ height: 14, marginLeft: 3, verticalAlign: 'text-top', outlineStyle: 'none' }} src={tooltipPath} alt={''} />
            </TooltipAnchor>
          </div>
        </th>
        <th className={'tb-data-grid-headers-line'}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'agent-status-column-header'}>
            {Messages.siteRemoteAgentStatusColumnName()}
            <Tooltip getContent={() => { return <span>{Messages.remoteAgentStatusPopoverDetail()}</span>; }}>
              <img style={{ height: 14, marginLeft: 3, verticalAlign: 'text-top', outlineStyle: 'none' }} src={tooltipPath} alt={''} />
            </Tooltip>
          </span>
        </th>
        <th className={'tb-data-grid-headers-line'}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'agent-last-connected-column-header'}>
            {Messages.siteRemoteAgentLastConnectedColumnName()}
          </span>
        </th>
        <th className={'tb-data-grid-headers-line'} data-tb-test-id={'agent-delete-column-header'}>
          {/*empty header for delete column*/}
        </th>
      </tr>
    </tbody>
  </>;
}

const clientUpdateHelpText = () => {
  const url = HelpService.getServerHelpUrlByCategory('bridge-release');
  const replacements = {
    TABLEAU_BRIDGE_RELEASES: () => <a href={url}>{Messages.remoteAgentVersionBridgeReleases()}</a>
  };
  return interpolateString(Messages.remoteAgentVersionPopoverDetail_new(), replacements);
};
